import { FC } from "react";
import styled, { keyframes } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

const fadeInScale = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.97);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Container = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "landings-start-page",
})`
  width: 100%;
  height: 100vh;
  background: linear-gradient(to bottom, #2d0076 0%, #ffffff 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter", sans-serif;
`;

const Banner = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "landings-banner",
})`
  padding: 1.5rem 3rem;
  border-radius: 1.5rem;
  background: linear-gradient(90deg, #7b00ff, #4c00b0);
  color: #ffffff;
  font-size: 2rem;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  user-select: none;
  animation: ${fadeInScale} 1.5s ease forwards;
  text-align: center;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 20px;
  }
`;

export const EmptyLandingsPage: FC = () => {
  return (
    <Container data-e2e-key="empty-landings-page">
      <Banner>Landings by Ryde</Banner>
    </Container>
  );
};
